<template>
    <div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">

        <!-- 左边 -->
        <div style="margin:5px;float:right">
            <el-button size="mini" type="success" @click="openModel">添加配套设施</el-button>
        </div>

        <el-table :data="tableData" border style="width: 100%" v-loading="loadings" :height="height"
            ref="configurationTable">
            <el-table-column prop="name" label="设施名称" show-overflow-tooltip align="center">
            </el-table-column>
            <el-table-column prop="content" label="图标" show-overflow-tooltip align="center">
                <template v-slot="scope">
                    <img :src="scope.row.icon"  width="40" height="40">
                </template>
            </el-table-column>
            <el-table-column label="操作" width="250" align="center">
                <template slot-scope="scope">
                    <el-button @click="handleClick(scope.row)" type="primary" size="mini">编辑</el-button>
                    <el-button @click="deleteClick(scope.row)" type="danger" size="mini">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- <div style="float:right">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="curPage"
                :page-sizes="[15, 30, 50, 100]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="count">
            </el-pagination>
        </div> -->



        <el-dialog :title="names" :visible.sync="dialogVisible" top='20px'>
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm">
                    <el-form-item label="名称">
                        <el-input v-model="ruleForm.name" placeholder="请输入内容" style="width:30%"></el-input>
                    </el-form-item>
                    <el-form-item label="内容">
                        <div>
                            <span v-if="!ruleForm.icon" class="btn btn-light border mr-2" @click="chooseImage">
                                <i class="el-icon-plus"></i>
                            </span>
                            <img v-else :src="ruleForm.icon" class="rounded"
                                style="width: 100px; height: 100px; cursor: pointer" @click="chooseImage" />
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false" size='small'>取 消</el-button>
                <el-button @click="subForm" size='small' type="primary">提交</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import buttonSearch from "@/components/common/button-search.vue"
    import common from '@/common/mixins/common.js';
    export default {
        inject: ['app', 'layout'],
        mixins: [common],
        components: {
            buttonSearch,

        },
        data() {
            return {
                tableData:[],
                loadings:false,
                height:null,
                names:'',
                dialogVisible:false,
                ruleForm:{
                    name:'',
                    icon:'',
                },
                rules:{},
                idlist:''
            }
        },
        computed: {

        },
        mounted() {
            let that = this
            that.search()
        },
        methods: {
           search(){
            let that = this
                that.loadings = true
                let url = `/admin/lgHomeDevice/index`;
                axios
                    .post(url, {},{
                        token: true
                    })
                    .then(response => {
                        that.tableData = response.data.data
                        that.loadings = false
                    })
                    .catch(error => {})
           },
           chooseImage() {
                this.app.chooseImage((res) => {
                    this.ruleForm.icon = res[0].url;
                    // this.ruleForm.icon.push(res[0].url);
                }, 1)
            },
           openModel(){
            let that = this
            that.dialogVisible = true
            that.names = '新增'
            that.ruleForm.name = ''
            that.ruleForm.icon = ''
           },
           handleClick(row){
            let that = this
            that.dialogVisible = true
            that.names = '编辑'
            that.idlist = row.id
            that.ruleForm.name = row.name
            that.ruleForm.icon = row.icon
           },
           subForm(){
             let that = this
             if(that.names == '新增'){
                axios.post('admin/lgHomeDevice/Madd',{
                    name:that.ruleForm.name,
                    icon:that.ruleForm.icon,
                },{
                    token: true
                }).then(res =>{
                    if (res.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: "success",
                                    message: res.data.msg,
                                });
                                that.dialogVisible = false;
                                that.search();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.data.msg,
                                    type: "error",
                                });
                            }
                }).catch(error =>{})
             }
             if(that.names == '编辑'){
                 axios.post('admin/lgHomeDevice/Medit',{
                    name:that.ruleForm.name,
                    icon:that.ruleForm.icon,
                    id:that.idlist
                },{
                    token: true
                }).then(res =>{
                    if (res.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: "success",
                                    message: res.data.msg,
                                });
                                that.dialogVisible = false;
                                that.search();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: res.data.msg,
                                    type: "error",
                                });
                            }
                }).catch(error =>{})
             }
           },
           deleteClick(row){
             let that = this
                that.fjids = row.id
                this.$confirm('此操作将永久删除该内容，是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post(
                            "/admin/lgHomeDevice/Mdelete", {
                                id:that.fjids,
                            }, {
                                token: true,
                            }
                        )
                        .then((response) => {
                            if (response.data.code == 200) {
                                this.$message({
                                    showClose: true,
                                    type: "success",
                                    message: response.data.msg,
                                });
                                that.search();
                            } else {
                                this.$message({
                                    showClose: true,
                                    message: response.data.msg,
                                    type: "error",
                                });
                            }
                        })
                        .catch((error) => {});
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
           },
        },
    }
</script>

<style>
</style>